export const DEFAULT_WISHLIST_NAME = "Favorites";
export const generateId = () => {
    if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
        return crypto.randomUUID();
    }
    return `wl_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
};
/**
 * If the customer has no wishlists yet, materialize a default "Favorites"
 * one so blocks always have a target ID to write to. Pure — caller decides
 * whether to persist the result.
 */
export const ensureDefaultWishlist = (wishlists) => {
    if (wishlists.length > 0)
        return wishlists;
    return [{ id: generateId(), name: DEFAULT_WISHLIST_NAME, items: [] }];
};
export const itemsEqual = (a, b) => { var _a, _b; return a.productId === b.productId && ((_a = a.variantId) !== null && _a !== void 0 ? _a : null) === ((_b = b.variantId) !== null && _b !== void 0 ? _b : null); };
